<template>
  <v-card
    class="pa-3 mb-2 d-flex align-center"
    width="100%"
    @click="clickHandler"
    outlined
  >
    <v-main>
      <slot />
    </v-main>
  </v-card>
</template>

<script>
export default {
  props: {
    url: String,
    blank: Boolean
  },
  methods: {
    clickHandler() {
      if (this.blank) {
        window.open(this.url, "_blank");
      } else {
        this.$router.push(this.url);
      }
    }
  }
};
</script>

<style>
</style>
